export default "__VITE_ASSET__48d44a5c__"